import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LsqCommonModule, LsqCoreModule, LsqModalsModule } from '@lsq-frontend/common-ui';

import { MfaBackupCodesModalComponent } from './mfa-backup-codes-modal.component';
import { MfaBackupCodesService } from './mfa-backup-codes.service';
import { UpdatePhoneNumberModalComponent } from './update-phone-number-modal.component';

@NgModule({
    imports: [CommonModule, LsqModalsModule, LsqCommonModule, LsqCoreModule],
    exports: [],
    declarations: [MfaBackupCodesModalComponent, UpdatePhoneNumberModalComponent],
    providers: []
})
export class MfaBackupCodesModule {}
